import type { RouteDefinition } from "./route-definition.ts";

export const resourcesRoutes = {
  episode: {
    path: "/episodes/:episodeId",
    scope: "resource",
    bucket: "app",
    entry: "workflow",
    disposition: "resolver",
  },
  episodeReplay: {
    path: "/episodes/:episodeId/replay",
    scope: "resource",
    bucket: "app",
    entry: "workflow",
    disposition: "page",
    gameOnly: true,
  },
  requestWatch: {
    path: "/episode-requests/:requestId/watch",
    scope: "resource",
    bucket: "app",
    entry: "workflow",
    disposition: "resolver",
  },
  lobby: {
    path: "/lobbies/:lobbyId",
    scope: "resource",
    bucket: "app",
    entry: "workflow",
    disposition: "resolver",
  },
  playSession: {
    path: "/play-sessions/:sessionId",
    scope: "resource",
    bucket: "app",
    entry: "workflow",
    disposition: "resolver",
  },
} as const satisfies Record<string, RouteDefinition>;
